export default __webpack_public_path__ + "static/media/portal_resources.8cb67287.png";